import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/FreightTemplates/FreightQuotation/components/SectionPurpose/SectionPurpose.module.scss';

const cn = classNames.bind(styles);

const SectionPurpose = (): ReactElement => {
  return (
    <section className={cn('purpose')}>
      <div className={cn('container')}>

        <div className={cn('purpose__section')}>

          <div className={cn('purpose__image-box')}>
            <picture>
              <source
                srcSet="
                /images/pages/Resources/FreightTemplates/sign-in.webp 1x,
                /images/pages/Resources/FreightTemplates/sign-in@2x.webp 2x
              "
                sizes="100vw"
              />
              <img
                className={cn('purpose__image')}
                src="/images/pages/Resources/FreightTemplates/sign-in.webp"
                alt="bill of lading"
              />
            </picture>
          </div>

          <div className={cn('purpose__content')}>
            <h2 className={cn('purpose__heading')}>
              <span>Why use a standardised</span>{' '}
              <span>Quote Template?</span>
            </h2>
            <p className={cn('purpose__paragraph')}>
              Speed and accuracy win deals.
            </p>
            <ul className={cn('purpose__list')}>
              <li className={cn('purpose__list-item')}>
                <span>Clarity:</span>{' '}
                It clearly separates "Prepaid" charges from "Collect" charges, so the shipper
                knows exactly what they are paying versus what their buyer is paying.
              </li>
              <li className={cn('purpose__list-item')}>
                <span>Protection:</span>{' '}
                By including standard inclusions and exclusions (e.g., "Excludes Duty &
                Tax"), you protect yourself from clients expecting you to pay their customs bills.
              </li>
              <li className={cn('purpose__list-item')}>
                <span>Professionalism:</span>{' '}
                A standardised PDF quote looks reliable. A text-heavy email with
                numbers scattered around looks risky.
              </li>
            </ul>
          </div>

        </div>

      </div>
    </section>
  );
};

export default SectionPurpose;